export const handleClickGlDevelopment = () => {
  window.open(
    "https://www.tg.org.au/what-we-do/guideline-development/",
    "_blank",
    "noopener,noreferrer",
  )
};